import { ServiceTasksOverviewDialog } from "@opstel/dialogs/ServiceTasksDialog/ServiceTasksOverviewDialog";
import { TrainUnitTransitionsDialog } from "@opstel/dialogs/TrainUnitTransitions/TrainUnitTransitionsDialog";
import { ScenarioBorderSelectionDialog } from "@opstel/dialogs/ScenarioBorderSelectionDialog/ScenarioBorderSelectionDialog";
import styled from "styled-components";

export function Prerequisites(): React.JSX.Element {
  return (
    <PrerequisitesContainer>
      <h2>Randvoorwaarden</h2>
      <ServiceTasksOverviewDialog />
      <TrainUnitTransitionsDialog />
      <ScenarioBorderSelectionDialog />
    </PrerequisitesContainer>
  );
}

const PrerequisitesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.spacing0.toString()};
`;
